export const getSkipCount = (current, pageSize) => (current - 1) * pageSize;
